import { Button } from 'component/Button'
import { Modal } from 'component/Modal'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { dataDeleteModal } from 'page/ProfileScreen/DataDeleteModal/DataDeleteModalStore'
import { controller } from 'store/controller'
import { deleteAllCookies } from 'util/cookie'

export const DataDeleteModal = observer(() => {
  const onCancel = useLatestCallback(async () => {
    dataDeleteModal.close()
  })

  const onDelete = useLatestCallback(async () => {
    await controller.deleteUser()
    deleteAllCookies()
    dataDeleteModal.close()
  })

  return <Modal onCancel={onCancel}>
    <Typo size={16}>{i18n('DeleteData')}</Typo>
    <Vertical gap={8}>
      <Button upper large flat error action={onDelete}>{i18n('DeleteData')}</Button>
      <Button upper large flat action={onCancel}>{i18n('Cancel')}</Button>
    </Vertical>
  </Modal>
})
